import { useMutation } from "@tanstack/react-query"
import { Link, useNavigate, useParams } from "react-router-dom"
import GameScreenLayout from "@/components/GameScreenLayout"
import { setActiveCard } from "@/api/gameApi"
import { useGuardiansPassport } from "@/features/passport/GuardiansPassportContext"
import { ELEMENT_NAMES, RANK_NAMES, STYLE_ICONS } from "@/constants/guardians"
import { displayCardBS } from "@/constants/game.constants"
import { GuardianCard } from "@/components/GuardianCard"

export default function CardDetailPage() {
  const { cardId } = useParams<{ cardId: string }>()
  const navigate = useNavigate()
  const { collectionCards, applyPassport, syncGameState, passport } =
    useGuardiansPassport()

  const card = collectionCards.find((c) => c.id === cardId)

  const activate = useMutation({
    mutationFn: () => setActiveCard(card!.id),
    onSuccess: async (updated) => {
      applyPassport(updated)
      await syncGameState()
      navigate("/play/collection")
    },
  })

  if (!card) {
    return (
      <GameScreenLayout title="Карта" backTo="/play/collection">
        <p className="text-sm text-guardians-muted">Карта не найдена</p>
      </GameScreenLayout>
    )
  }

  const isActive =
    passport?.activeCardId === card.id || passport?.activeCard?.id === card.id

  return (
    <GameScreenLayout title="Карта" backTo="/play/collection">
      <div className="mx-auto flex justify-center">
        <GuardianCard card={card} size="lg" isActive={isActive} />
      </div>
      <dl className="mt-4 space-y-2 text-sm">
        <div className="flex justify-between">
          <dt className="text-guardians-muted">Стихия</dt>
          <dd>{ELEMENT_NAMES[card.element]}</dd>
        </div>
        <div className="flex justify-between">
          <dt className="text-guardians-muted">Стиль</dt>
          <dd>{STYLE_ICONS[card.style]}</dd>
        </div>
        <div className="flex justify-between">
          <dt className="text-guardians-muted">Ранг</dt>
          <dd>{RANK_NAMES[card.colorRank]}</dd>
        </div>
        <div className="flex justify-between">
          <dt className="text-guardians-muted">Уровень</dt>
          <dd>{card.level}</dd>
        </div>
        <div className="flex justify-between">
          <dt className="text-guardians-muted">BS</dt>
          <dd>{displayCardBS(card)}</dd>
        </div>
      </dl>
      <div className="mt-6 flex flex-col gap-2">
        {!isActive ? (
          <button
            type="button"
            disabled={activate.isPending}
            onClick={() => activate.mutate()}
            className="w-full rounded-xl bg-guardians-accent py-3 text-sm font-medium text-guardians-bg"
          >
            Сделать активной
          </button>
        ) : (
          <p className="text-center text-sm text-guardians-accent">Активная карта</p>
        )}
        <Link
          to={`/play/cards/${encodeURIComponent(card.id)}/rank-exam`}
          className="rounded-xl border border-white/15 py-2.5 text-center text-sm"
        >
          Экзамен ранга
        </Link>
        <Link
          to={`/play/fuse?mainCardId=${encodeURIComponent(card.id)}`}
          className="rounded-xl border border-white/15 py-2.5 text-center text-sm"
        >
          Слияние карт
        </Link>
        <Link
          to="/play/wardrobe"
          className="rounded-xl border border-white/15 py-2.5 text-center text-sm"
        >
          Гардероб / стиль
        </Link>
      </div>
    </GameScreenLayout>
  )
}
